import { createFileRoute } from '@tanstack/react-router';
import AuthenticateRoute from 'src/components/organisms/app-layouts/authenticate-route/authenticate-route';
import ContactsView from 'src/components/views/contacts-view/contacts-view';

export const Route = createFileRoute('/contacts/')({
  component: ContactsIndexComponent,
});

// Example to add nested routes
// https://tanstack.com/router/latest/docs/framework/react/examples/basic-file-based
function ContactsIndexComponent() {
  return (
    <AuthenticateRoute>
      <ContactsView />
    </AuthenticateRoute>
  );
}
